<template>
  <a-result v-if="!expand.code" class="box_result" status="info"
            title="正在登录" sub-title="微信信息校验中..." />
  <div v-else class="box_code">
    <img :src="expand.code" alt="" />
    <div class="content">
      <div class="title">扫码完成注册</div>
      <div class="steps">
        <div class="step">
          <span class="step-num">1.</span>
          <span class="step-text">打开微信，使用"扫一扫"功能</span>
        </div>
        <div class="step">
          <span class="step-num">2.</span>
          <span class="step-text">扫描上方二维码</span>
        </div>
        <div class="step">
          <span class="step-num">3.</span>
          <span class="step-text">在微信中完成注册</span>
        </div>
      </div>
      <a-button type="primary" @click="goBack" class="back-btn">返回</a-button>
    </div>
  </div>
</template>

<script lang="ts">
import QRCode from 'qrcode';

import { DataInterface } from '@interface/public';
import {
  WeChatSceneEnum,
  RequestWeChatLogin, ResponseWeChatLogin, AxiosWeChatLogin
} from '@server/apiSSO';

export default {
  name: 'channel_loginWeChat',
  data(): DataInterface {
    return {
      request: {
        intercept: {
          login: false
        }
      },
      form: {
        data: {
          state: this.$route.query.state || '',
          code: this.$route.query.code || ''
        }
      },
      expand: {
        code: ''
      }
    };
  },
  mounted(): void {
    console.log('[channelWeChat] mounted 被触发');
    console.log('[channelWeChat] 当前路由:', this.$route.path);
    console.log('[channelWeChat] 查询参数:', this.$route.query);
    console.log('[channelWeChat] form.data:', this.form.data);
    console.log('[channelWeChat] 登录状态:', $RQ.SSO.check());
    
    // $RQ.PushWebHookFeiShu(
    //   '微信授权',
    //   `微信授权: ${  $RQ.SSO.check() ? '已登录' : '未登录' }`
    // );
    $RQ.SSO.check()
      ? this.$router.push($Enum.RouterEnum.Replenish)
      : this.login();
  },
  unmounted(): void {
    // 组件卸载时的清理
  },
  methods: {
    /**
     * 返回上一页
     */
    goBack(): void {
      this.$router.push($Enum.RouterEnum.Back);
    },

    /**
     * 登录
     */
    async login(): Promise<any> {
      if (!this.form.data.state || !this.form.data.code) {
        this.$router.push($Enum.RouterEnum.SSOIndex);
        return;
      }
      if (this.request.intercept.login) return;
      this.request.intercept.login = true;
      
      await AxiosWeChatLogin({
        app_id: $FN.Agent.browser() === 'WeChat'
          ? $Config.ID.weChatServer
          : $Config.ID.weChatWebApp,
        code: this.form.data.code,
        state: this.form.data.state,
        scene: $FN.Agent.client() === 'PC'
          ? WeChatSceneEnum.PC
          : WeChatSceneEnum.Mobile
      } as RequestWeChatLogin)
        .then(async (response: any) => {
          const data: ResponseWeChatLogin = response.data;
          // $RQ.PushWebHookFeiShu(
          //   '微信绑定手机号检查结果',
          //   `微信登录: ${ JSON.stringify(data) }`
          // );
          if (data.code === $Enum.CodeEnum.UserCanceling) {
            this.handleCancelingUser(data);
            return;
          }
          if (data.code !== $Enum.CodeEnum.Normal) {
            this.$router.push($Enum.RouterEnum.SSOIndex);
            return;
          }
          
          if (data.data.is_bound) {
            $Store.User().updateInfo({
              token: data.data.token,
              userID: data.data.user_id,
              username: data.data.name
            });
            !$Store.User().operate && $Store.User().$patch({
              operate: $Enum.OperateEnum.Login
            });
            
            $FN.Message('success', {
              content: $Enum.TextEnum.SuccessLogin
            });
            
            this.$router.push($Enum.RouterEnum.Replenish);
            
            $RQ.PushWebHookFeiShu(
              $Store.User().username,
              `微信${ $Enum.TextEnum.OperateLogin }：${ $Store.User().source || location.href }`
            );
          } else {
            // $RQ.PushWebHookFeiShu(
            //   '$Store.User().username',
            //   `微信未绑定手机号：${$Store.User().operate === $Enum.OperateEnum.WeChatLogin && $FN.Agent.client() === 'PC' ? 'PC端' : '移动端'},wechat_uid:${ data.data.wechat_uid }`
            // );
            // PC端：显示二维码引导用户扫码注册
            if ($Store.User().operate === $Enum.OperateEnum.WeChatLogin && $FN.Agent.client() === 'PC') {
              this.expand.code = await QRCode.toDataURL(`${ $Config.Href.sso + $Enum.RouterEnum.SSOIndex }?wechat=${ data.data.wechat_uid }`);
              return;
            }
            this.$router.push({
              path: $Enum.RouterEnum.SSOIndex,
              query: {
                wechat: data.data.wechat_uid,
                un_bound:!data.data.is_bound
              }
            });
          }
        })
        .finally(() => {
          this.request.intercept.login = false;
        });
    },
    
    /**
     * 处理注销中登录
     * @param {*} data 登录结果
     */
    handleCancelingUser(data: any): void {
      if (!data.data?.token) {
        this.$router.push($Enum.RouterEnum.SSOIndex);
        return;
      }
      
      const cancelledAt = data.data.cancelled_at || data.data.cancelledAt ||
        data.cancelled_at || data.cancelledAt || '';
      cancelledAt &&
      typeof sessionStorage !== 'undefined' &&
      sessionStorage.setItem('GFStopCancelCancelledAt', cancelledAt);
      
      $Store.User().updateInfo({
        token: data.data.token,
        userID: data.data.user_id || data.data.uid || '-',
        username: data.data.name || data.data.user_id || data.data.uid || '-'
      });
      !$Store.User().operate && $Store.User().$patch({
        operate: $Enum.OperateEnum.StopCancel
      });
      
      this.$router.push({
        path: $Enum.RouterEnum.StopCancel,
        query: {
          cancelled_at: cancelledAt
        }
      });
    }
  }
};
</script>

<style lang="less" rel="stylesheet/less" scoped>
@import '@resource/css/_global.less';

@image: '@{src_image}sso/';

.box_code {
  box-sizing: border-box;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: max-content;
  height: max-content;
  padding: 20px;
  margin: auto;
  border-radius: 10px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  background: @color_white;

  img {
    @wh: 300px;
    display: block;
    width: @wh;
    height: @wh;
    margin: 0 auto;
    border-radius: 10px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  }

  .content {
    margin-top: 20px;
    text-align: center;

    .title {
      font-size: 18px;
      font-weight: 600;
      margin-bottom: 20px;
      color: #333;
    }

    .steps {
      text-align: left;
      margin-bottom: 20px;

      .step {
        display: flex;
        align-items: flex-start;
        margin-bottom: 12px;
        line-height: 1.6;

        .step-num {
          font-weight: 600;
          color: #1890ff;
          margin-right: 8px;
          min-width: 20px;
        }

        .step-text {
          color: #666;
          font-size: 14px;
        }
      }
    }

    .back-btn {
      width: 100%;
      height: 40px;
      font-size: 16px;
    }
  }
}
</style>
